module.exports = __webpack_public_path__ + "img/kitInactivo.838c72a6.svg";